module.exports = __webpack_public_path__ + "static/media/mangal-regular.7bd2ecd2.woff";